// eslint-disable-next-line import/prefer-default-export
export const REPOSITORY = Object.freeze({
  FOLDER: "folder",
  DOCUMENT: "document",
});

